import { Component, Input, OnInit } from '@angular/core';
import { User, VerifiedStatus } from 'anchor-shared/lib/model/entity/user';
import { take } from 'rxjs/operators';
import { EnvironmentalMediaService } from '../../../../../core/services/environmental-media.service';
import { StripePaymentDAO } from '../../../../../core/services/dao/stripePaymentDAO';
import { Stripe } from '@stripe/stripe-js';
import { ExternalScriptService } from '../../../../../core/services/stripe.service';

@Component({
  selector: 'app-id-upload-heading-text',
  templateUrl: './id-upload-heading-text.component.html',
  styleUrls: ['./id-upload-heading-text.component.scss'],
})
export class IdUploadHeadingTextComponent implements OnInit {
  userIdentityVerification;
  stripe: any;

  @Input()
  user: User;

  @Input()
  isAdmin: boolean;

  stripeLoaded: boolean;

  constructor(
    private readonly environmentalMediaService: EnvironmentalMediaService,
    private readonly stripePaymentDao: StripePaymentDAO,
    private externalScriptService: ExternalScriptService,
  ) {
    externalScriptService.loadStripe().then(() => {
      console.log('loaded in Component');
      this.stripeLoaded = true;
      // @ts-ignore is global
      this.stripe = Stripe(
        this.environmentalMediaService.getStripePublishableKey(),
      );
    });
  }

  ngOnInit() {}

  getUserIdentityVerification() {
    this.stripePaymentDao
      .getIdentityVerification()
      .pipe(take(1))
      .subscribe(async (session) => {
        this.userIdentityVerification = session;
        const { error } = await this.stripe.verifyIdentity(
          session.client_secret,
        );
        if (!error) {
          this.user.verifiedStatus = VerifiedStatus.PROCESSING;
        } else {
          console.log(this.user.id, error);
        }
      });
  }
}
